// NOTE: This file is not used

import type { NativeStackNavigationProp } from "@react-navigation/native-stack";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

import SelectOptionScreen from "../components/SelectOptionScreen";
import { commonStyles, Routes } from "../constants";

type ParamList = {
  AddLifeStyleScreen: undefined;
  ProfileStartScreen: undefined;
};
type Props = {
  navigation: NativeStackNavigationProp<ParamList, "AddLifeStyleScreen">;
};

const optionsData = [
  {
    id: 0,
    label: "Sitting",
    description: "office job",
  },
  {
    id: 1,
    label: "Light active",
    description: "Walking the dog every day, or cycling to \nwork",
  },
  {
    id: 2,
    label: "Active",
    description: "Personal trainer or service; most of the\ntime standing or walking",
  },
  {
    id: 3,
    label: "Very Active",
    description: "road worker; working intensively with \n(heavy) materials",
  },
];

const AddLifeStyleScreen = ({ navigation }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <View style={commonStyles.container}>
      <SelectOptionScreen
        pageTitle={"How physically taxing is your lifestyle?"}
        pageDescription={"Excluding sports or cardio"}
        optionsData={optionsData}
        buttonText={"Next"}
        onButtonPress={() => {
          navigation.push(Routes.AddMotivationGoalScreen as keyof ParamList);
        }}
        multipleSelectionsAllowed={false}
        // FIXME:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        navigation={navigation}
      />
    </View>
  );
};
export default AddLifeStyleScreen;
